import React from 'react';
import PageTitle from '../components/PageTitle/PageTitle';

const Dashboard = () => <PageTitle title="Home" />;

export default Dashboard;
